import React from 'react';
import donateData from '../data/donate.json';

const helpAreaIcons = ['📚', '🔧', '👶', '🤝'];

function Donate() {
  const { hero, helpAreasTitle, helpAreas, impact, banking, involvement, cta } = donateData;

  return (
    <div className="fade-in">
      <div className="hero">
        <h1>{hero.title}</h1>
        <p>{hero.subtitle}</p>
      </div>

      <div className="content-section container">
        <h2>{helpAreasTitle}</h2>
        <div className="cards-container">
          {helpAreas.map((area, index) => (
            <div key={area.title} className="card">
              <h3>{helpAreaIcons[index]} {area.title}</h3>
              <p>{area.text}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="content-section container">
        <h2>{impact.sectionTitle}</h2>
        <div className="program-card">
          <h3>{impact.title}</h3>
          <p>{impact.text}</p>
          <ul>
            {impact.points.map((point) => (
              <li key={point}>✅ {point}</li>
            ))}
          </ul>
        </div>
      </div>

      <div className="content-section container">
        <h2>{banking.sectionTitle}</h2>
        <div className="contact-box" style={{ background: 'linear-gradient(to bottom, #fff 0%, #f8f9fa 100%)', borderLeft: '4px solid #66BB6A', padding: '2rem' }}>
          <h3 style={{ fontSize: '1.5rem', marginBottom: '1.5rem' }}>{banking.title}</h3>
          <div style={{ fontSize: '1.1rem' }}>
            <p><strong>{banking.labels.bank}:</strong> {banking.bank}</p>
            <p><strong>{banking.labels.accountName}:</strong> {banking.accountName}</p>
            <p><strong>{banking.labels.accountType}:</strong> {banking.accountType}</p>
            <p><strong>{banking.labels.accountNumber}:</strong> {banking.accountNumber}</p>
            <p><strong>{banking.labels.branchCode}:</strong> {banking.branchCode}</p>
          </div>
          <div style={{ marginTop: '2rem', padding: '1rem', background: '#e8f5e9', borderRadius: '8px' }}>
            <p style={{ fontStyle: 'italic', margin: 0 }}>
              ℹ️ <strong>{banking.labels.taxBenefits}:</strong> {banking.taxNote}
            </p>
          </div>
        </div>
      </div>

      <div className="content-section container" style={{ textAlign: 'center' }}>
        <div className="cards-container">
          {involvement.map((item) => (
            <div key={item.title} className="card">
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="content-section container" style={{ textAlign: 'center', background: 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)', padding: '3rem' }}>
        <h2 style={{ color: '#2E7D32' }}>{cta.title}</h2>
        <p style={{ fontSize: '1.2rem', marginBottom: '2rem' }}>
          {cta.text}
        </p>
        <a href={cta.link} className="btn" style={{ fontSize: '1.1rem', padding: '1rem 2rem' }}>{cta.label}</a>
      </div>
    </div>
  );
}

export default Donate;
